// FETCH ALL RESTAURANTS
export const FETCH_ALL_RESTAURANTS_SAGA = "FETCH_ALL_RESTAURANTS_SAGA";
export const FETCH_ALL_RESTAURANTS_SUCCESS = "FETCH_ALL_RESTAURANTS_SUCCESS";
export const FETCH_ALL_RESTAURANTS_ERROR = "FETCH_ALL_RESTAURANTS_ERROR";

//FETCH LOCATIONS
export const FETCH_LOCATIONS_SAGA = "FETCH_LOCATIONS_SAGA";
export const FETCH_LOCATIONS_SUCCESS = "FETCH_LOCATIONS_SUCCESS";

// FETCH ALL RESTAURANT GROUPS
export const FETCH_RESTAURANT_GROUPS_SUCCESS =
  "FETCH_RESTAURANT_GROUPS_SUCCESS";
export const FETCH_RESTAURANT_GROUPS_SAGA = "FETCH_RESTURANT_GROUPS_SAGA";

// FETCH ALL LOCATIONS
export const FETCH_ALL_LOCATIONS_SAGA = "FETCH_ALL_LOCATIONS_SAGA";
export const FETCH_PICKUP_TIME = "FETCH_PICKUP_TIME";
export const FETCH_ALL_LOCATIONS = "FETCH_ALL_LOCATIONS";
export const FETCH_ALL_LOCATIONS_SUCCESS = "FETCH_ALL_LOCATIONS_SUCCESS";
export const FETCH_ALL_LOCATIONS_ERROR = "FETCH_ALL_LOCATIONS_ERROR";

//
export const DELETE_LOCATION_SAGA = "DELETE_LOCATION_SAGA";

//
export const SET_LOCATION_DRAWER_LOADING = "SET_LOCATION_DRAWER_LOADING";

// CURRENT LOCATION

export const SET_CURR_LOCATION = "SET_CURR_LOCATION";

// CURRENT REST
export const SET_CURR_REST = "SET_CURR_REST";

export const SET_CURRENT_RESTAURANT_GROUP_ID =
  "SET_CURRENT_RESTAURANT_GROUP_ID";

// GET IIKO ORGANIZATIONS
export const FETCH_ORGANIZATION_SAGA = "FETCH_ORGANIZATION_SAGA";

export const FETCH_ORGANIZATIONS = "FETCH_ORGANIZATIONS";
export const FETCH_ORGANIZATIONS_SUCCESS = "FETCH_ORGANIZATIONS_SUCCESS";
export const FETCH_ORGANIZATIONS_ERROR = "FETCH_ORGANIZATIONS_ERROR";

export const FETCH_CASH_SYSTEM_SUCCESS = "FETCH_CASH_SYSTEM_SUCCESS";
export const FETCH_CASH_SYSTEM_SAGA = "FETCH_CASH_SYSTEM_SAGA";

//GET AGGREGATOR PAYMENT_TYPES
export const FETCH_PAYMENT_TYPES = "FETCH_PAYMENT_TYPES";
export const FETCH_PAYMENT_TYPES_SUCCESS = "FETCH_PAYMENT_TYPES_SUCCESS";
export const FETCH_PAYMENT_TYPES_ERROR = "FETCH_PAYMENT_TYPES_ERROR";
export const FETCH_PAYMENT_TYPES_SAGA = "FETCH_PAYMENT_TYPES_SAGA";

// SEND IIKO ORGANIZATIONS
export const SEND_IIKO_ORGANIZATIONS_SAGA = "SEND_IIKO_ORGANIZATIONS_SAGA";

export const SEND_IIKO_ORGANIZATIONS = "SEND_IIKO_ORGANIZATIONS";
export const SEND_IIKO_ORGANIZATIONS_SUCCESS = "SEND_IIKO_ORGANIZATIONS";
export const SEND_IIKO_ORGANIZATIONS_ERROR = "SEND_IIKO_ORGANIZATIONS_ERROR";

// Disable Location Integration
export const SWITCH_LOCATION_INTEGRATION_MODE =
  "SWITCH_LOCATION_INTEGRATION_MODE";

// CREATE GLOVO INTEGRATION
export const CREATE_GLOVO_INTEGRATION = "CREATE_GLOVO_INTEGRATION";
export const CREATE_WOLT_INTEGRATION_SAGA = "CREATE_WOLT_INTEGRATION_SAGA";
export const CREATE_GLOVO_INTEGRATION_SUCCESS =
  "CREATE_GLOVO_INTEGRATION_SUCCESS";

// GET LOCATION BY ID
export const GET_LOCATION_BY_ID_SAGA = "GET_LOCATION_BY_ID_SAGA";
export const GET_LOCATION_BY_ID_SUCCESS = "GET_LOCATION_BY_ID_SUCCESS";

// EDIT LOCATION
export const EDIT_LOCATION_ITEM_SAGA = "EDIT_LOCATION_ITEM_SAGA";
// CLEAN LOCATIONFORM
export const CLEAN_LOCATION_FORM = "CLEAN_LOCATION_FORM";

// SUBMIT BTN STATUS
export const SET_NEXT_IN_PROGRESS_LOADER = "SET_NEXT_IN_PROGRESS_LOADER";

//
export const EDIT_CASH_SYSTEM_SAGA = "EDIT_CASH_SYSTEM_SAGA";

export const PATCH_INTEGRATION_SAGA = "PATCH_INTEGRATION_SAGA";

// GET CURRENCIES LANGUAGES
export const GET_LANGUAGES_SAGA = "GET_LANGUAGES_SAGA";
export const GET_LANGUAGES_SUCCESS = "GET_LANGUAGES_SUCCESS";

export const GET_CURRENCIES_SAGA = "GET_CURRENCIES_SAGA";
export const GET_CURRENCIES_SUCCESS = "GET_CURRENCIES_SUCCESS";

export const GET_AGGREGATOR_DATA_SAGA = "GET_AGGREGATOR_DATA_SAGA";
export const GET_AGGREGATOR_DATA_SUCCESS = "GET_AGGREGATOR_DATA_SUCCESS";
export const GET_AGGREGATOR_DATA_ERROR = "GET_AGGREGATOR_DATA_ERROR";

// FETCH ORDER TYPES

export const FETCH_ORDER_TYPES_SAGA = "FETCH_ORDER_TYPES_SAGA";
export const FETCH_ORDER_TYPES_SUCCESS = "FETCH_ORDER_TYPES_SUCCESS";

export const UPDATE_AGGREGATOR_DATA_SAGA = "UPDATE_AGGREGATOR_DATA_SAGA";

export const CLEAR_AGGREGATOR_DATA = "CLEAR_AGGREGATOR_DATA";

// PALOMA  POS IDS
export const GET_POS_IDS_SAGA = "GET_POS_IDS_SAGA";
export const GET_POS_IDS_SUCCESS = "GET_POS_IDS_SUCCESS";

// YANDEX

export const GET_YANDEX_CREDENTIALS_SAGA = "GET_YANDEX_CREDENTIALS_SAGA";
export const GET_YANDEX_CREDENTIALS_SUCCESS = "GET_YANDEX_CREDENTIALS_SUCCESS";

export const CREATE_YANDEX_INTEGRATION_SAGA = "CREATE_YANDEX_INTEGRATION_SAGA";

//USER LIST

export const GET_USER_LIST_SAGA = "GET_USER_LIST_SAGA";
export const GET_USER_LIST_SUCESS = "GET_USER_LIST_SUCESS";

// EDIT CHECK FIELDS

export const EDIT_CHECK_FIELDS_SAGA = "EDIT_CHECK_FIELDS_SAGA";
